// src/App.jsx
import "./App.css";
import Navbar from "./components/Navbar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import AboutUs from "./pages/About";
import ServicesPage from "./pages/ServicesPage";
import DataBuildServices from "./pages/DataBuildServices";
import CustomerSupportServices from "./pages/CustomerSupportServices";
import WebinarRegistrationServices from "./pages/WebinarRegistrationServices";
import TelecallingServices from "./pages/TelecallingServices";
import LeadGenerationPage from "./pages/LeadGenerationPage";
import ContactPage from "./pages/ContactPage";
import Carreies from "./pages/Carreies";
import ErrorPage from "./pages/Error";
import MortgageServices from "./pages/MortgageServices";
// import WhatsAppChat from "./pages/Whatapps";

import Footer from "./components/Footer";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/dataBuildservices" element={<DataBuildServices />} />
        <Route path="/mortgageservices" element={<MortgageServices />} />
        <Route
          path="/customersupportservices"
          element={<CustomerSupportServices />}
        />
        <Route
          path="/WebinarRegistrationServices"
          element={<WebinarRegistrationServices />}
        />
        <Route path="/telecallingservices" element={<TelecallingServices />} />
        <Route path="/leadgenration" element={<LeadGenerationPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/career" element={<Carreies />} />

        {/* Catch-all route for undefined URLs */}
        <Route path="*" element={<ErrorPage />} />
      </Routes>
      {/* <WhatsAppChat/> */}
      <Footer />
    </Router>
  );
}

export default App;
